/* src/app/admin/admin-menu/admin-menu.component.scss */
/*# sourceMappingURL=admin-menu.component-2ZORJCCW.css.map */
